// === CONFIGURACIÓN DE BRANDING DINÁMICO ===

// Función para obtener variables de entorno con valores por defecto
const getEnvVar = (key, defaultValue = '') => {
  return process.env[key] || defaultValue;
};

// Configuración de la Empresa
export const COMPANY_CONFIG = {
  name: getEnvVar('REACT_APP_COMPANY_NAME', 'BUDGET DIGITAL SOLUTIONS'),
  tagline: getEnvVar('REACT_APP_COMPANY_TAGLINE', 'Sistema Profesional de Seguros'),
  phone: getEnvVar('REACT_APP_COMPANY_PHONE', '+1 (555) 123-4567'),
  email: getEnvVar('REACT_APP_COMPANY_EMAIL', 'info@budgetdigitalsolutions.com'),
  supportEmail: getEnvVar('REACT_APP_SUPPORT_EMAIL', 'soporte@budgetdigitalsolutions.com'),
};

// Configuración de Colores
export const THEME_CONFIG = {
  primary: `#${getEnvVar('REACT_APP_PRIMARY_COLOR', '006400')}`,
  accent: `#${getEnvVar('REACT_APP_ACCENT_COLOR', 'FFD700')}`,
  background: `#${getEnvVar('REACT_APP_BACKGROUND_COLOR', 'f8fafc')}`,
  text: `#${getEnvVar('REACT_APP_TEXT_COLOR', '1f2937')}`,
  
  // Generar variaciones automáticamente
  get primaryHover() {
    return this.darkenColor(this.primary, 0.1);
  },
  get primaryLight() {
    return this.lightenColor(this.primary, 0.1);
  },
  get accentHover() {
    return this.darkenColor(this.accent, 0.1);
  },
  
  // Utilidades de color
  darkenColor(color, amount) {
    const num = parseInt(color.replace('#', ''), 16);
    const amt = Math.round(2.55 * amount * 100);
    const R = (num >> 16) - amt;
    const G = (num >> 8 & 0x00FF) - amt;
    const B = (num & 0x0000FF) - amt;
    return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
      (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
      (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
  },
  
  lightenColor(color, amount) {
    const num = parseInt(color.replace('#', ''), 16);
    const amt = Math.round(2.55 * amount * 100);
    const R = (num >> 16) + amt;
    const G = (num >> 8 & 0x00FF) + amt;
    const B = (num & 0x0000FF) + amt;
    return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
      (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
      (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
  }
};

// Configuración de Assets
export const ASSETS_CONFIG = {
  logo: getEnvVar('REACT_APP_LOGO_PATH', 'logo.svg'),
  favicon: getEnvVar('REACT_APP_FAVICON_PATH', 'favicon.ico'),
  logoSmall: getEnvVar('REACT_APP_LOGO_SMALL_PATH', 'logo-small.svg'),
};

// Configuración de la Aplicación
export const APP_CONFIG = {
  title: getEnvVar('REACT_APP_APP_TITLE', 'CRM INS PRO'),
  loginTitle: getEnvVar('REACT_APP_LOGIN_TITLE', 'Login to CRM INS PRO'),
  dashboardTitle: getEnvVar('REACT_APP_DASHBOARD_TITLE', 'CRM INS PRO Dashboard'),
};

// Configuración de Redes Sociales
export const SOCIAL_CONFIG = {
  facebook: getEnvVar('REACT_APP_FACEBOOK_URL', ''),
  twitter: getEnvVar('REACT_APP_TWITTER_URL', ''),
  linkedin: getEnvVar('REACT_APP_LINKEDIN_URL', ''),
  website: getEnvVar('REACT_APP_WEBSITE_URL', ''),
};

// Configuración Regional
export const LOCALE_CONFIG = {
  locale: getEnvVar('REACT_APP_LOCALE', 'es-US'),
  currency: getEnvVar('REACT_APP_CURRENCY', 'USD'),
  dateFormat: getEnvVar('REACT_APP_DATE_FORMAT', 'MM/DD/YYYY'),
  timeZone: getEnvVar('REACT_APP_TIME_ZONE', 'America/New_York'),
};

// Temas Predefinidos
export const PREDEFINED_THEMES = {
  professional: {
    name: 'Profesional',
    primary: '#006400',
    accent: '#FFD700',
    description: 'Verde profesional con acentos dorados'
  },
  corporate: {
    name: 'Corporativo',
    primary: '#1e40af',
    accent: '#f59e0b',
    description: 'Azul corporativo con acentos naranjas'
  },
  modern: {
    name: 'Moderno',
    primary: '#7c3aed',
    accent: '#10b981',
    description: 'Púrpura moderno con acentos verdes'
  },
  elegant: {
    name: 'Elegante',
    primary: '#1f2937',
    accent: '#f59e0b',
    description: 'Gris elegante con acentos naranjas'
  },
  energetic: {
    name: 'Energético',
    primary: '#dc2626',
    accent: '#059669',
    description: 'Rojo energético con acentos verdes'
  }
};

// Función para aplicar tema CSS
export const applyTheme = (theme = null) => {
  const root = document.documentElement;
  
  // Si no se especifica tema, usar configuración actual
  const colors = theme || THEME_CONFIG;
  
  // Aplicar variables CSS
  root.style.setProperty('--primary-color', colors.primary);
  root.style.setProperty('--primary-hover', colors.primaryHover);
  root.style.setProperty('--primary-light', colors.primaryLight);
  root.style.setProperty('--accent-color', colors.accent);
  root.style.setProperty('--accent-hover', colors.accentHover);
  root.style.setProperty('--background-color', colors.background);
  root.style.setProperty('--text-color', colors.text);
  
  // Actualizar el atributo data-theme
  document.body.setAttribute('data-theme', theme?.name || 'custom');
  
  console.log('🎨 Tema aplicado:', theme?.name || 'personalizado');
};

// Función para cargar configuración personalizada
export const loadCustomBranding = () => {
  try {
    // Aplicar tema al inicializar
    applyTheme();
    
    // Actualizar título de la página
    document.title = `${COMPANY_CONFIG.name} - ${APP_CONFIG.title}`;
    
    // Actualizar favicon si existe
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = `/assets/${ASSETS_CONFIG.favicon}`;
    }
    
    console.log('✅ Configuración de branding cargada:', COMPANY_CONFIG.name);
  } catch (error) {
    console.error('❌ Error cargando configuración de branding:', error);
  }
};

// Función para validar configuración de branding
export const validateBrandingConfig = () => {
  const errors = [];
  
  if (!COMPANY_CONFIG.name) errors.push('Nombre de empresa requerido');
  if (!THEME_CONFIG.primary.match(new RegExp('^#[0-9A-Fa-f]{6}$'))) errors.push('Color primario inválido');
  if (!THEME_CONFIG.accent.match(new RegExp('^#[0-9A-Fa-f]{6}$'))) errors.push('Color de acento inválido');
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Función para exportar configuración actual
export const exportBrandingConfig = () => {
  return {
    company: COMPANY_CONFIG,
    theme: THEME_CONFIG,
    assets: ASSETS_CONFIG,
    app: APP_CONFIG,
    social: SOCIAL_CONFIG,
    locale: LOCALE_CONFIG,
    exportedAt: new Date().toISOString()
  };
};

// Función para generar archivo .env con configuración actual
export const generateEnvFile = (customConfig = {}) => {
  const config = { ...COMPANY_CONFIG, ...THEME_CONFIG, ...customConfig };
  
  return `# === CONFIGURACIÓN DE MARCA/BRANDING ===
# Generado automáticamente el ${new Date().toLocaleString()}

# Información de la Empresa
REACT_APP_COMPANY_NAME="${config.name || COMPANY_CONFIG.name}"
REACT_APP_COMPANY_TAGLINE="${config.tagline || COMPANY_CONFIG.tagline}"
REACT_APP_COMPANY_PHONE="${config.phone || COMPANY_CONFIG.phone}"
REACT_APP_COMPANY_EMAIL="${config.email || COMPANY_CONFIG.email}"
REACT_APP_SUPPORT_EMAIL="${config.supportEmail || COMPANY_CONFIG.supportEmail}"

# Colores de Marca (sin #)
REACT_APP_PRIMARY_COLOR="${(config.primary || THEME_CONFIG.primary).replace('#', '')}"
REACT_APP_ACCENT_COLOR="${(config.accent || THEME_CONFIG.accent).replace('#', '')}"
REACT_APP_BACKGROUND_COLOR="${(config.background || THEME_CONFIG.background).replace('#', '')}"
REACT_APP_TEXT_COLOR="${(config.text || THEME_CONFIG.text).replace('#', '')}"

# Logos y Assets
REACT_APP_LOGO_PATH="${config.logo || ASSETS_CONFIG.logo}"
REACT_APP_FAVICON_PATH="${config.favicon || ASSETS_CONFIG.favicon}"
REACT_APP_LOGO_SMALL_PATH="${config.logoSmall || ASSETS_CONFIG.logoSmall}"

# Configuración de la Aplicación
REACT_APP_APP_TITLE="${config.title || APP_CONFIG.title}"
REACT_APP_LOGIN_TITLE="${config.loginTitle || APP_CONFIG.loginTitle}"
REACT_APP_DASHBOARD_TITLE="${config.dashboardTitle || APP_CONFIG.dashboardTitle}"
`;
};

// Auto-inicializar al importar
if (typeof window !== 'undefined') {
  // Solo ejecutar en el navegador
  document.addEventListener('DOMContentLoaded', loadCustomBranding);
  
  // Si ya está cargado el DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCustomBranding);
  } else {
    loadCustomBranding();
  }
}

export default {
  COMPANY_CONFIG,
  THEME_CONFIG,
  ASSETS_CONFIG,
  APP_CONFIG,
  SOCIAL_CONFIG,
  LOCALE_CONFIG,
  PREDEFINED_THEMES,
  applyTheme,
  loadCustomBranding,
  validateBrandingConfig,
  exportBrandingConfig,
  generateEnvFile
};